export default __webpack_public_path__ + "static/media/default_white@2x.523aee4e.webp";